import React from "react";
import PageWrapper from "../Components/PageWrapper";

const Blog = () => {
  return (
    <PageWrapper>
      <h1>Blog</h1>
    </PageWrapper>
  );
};

export default Blog;
